var React = require('react');

function V01 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path"),React.createElement("g",{"id":"4.-20210908-小企業","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"/202106-event","transform":"translate(0.000000, -1343.000000)","fill":"#4328CA"},React.createElement("path",{"d":"M100,1393 C72.6612151,1393 50.4482243,1414.9396 50.0066984,1442.17226 L50,1442.9991 L0,1442.9991 C0,1387.77104 44.7710351,1343 100,1343 L100,1393 Z","id":"Path"})))]);
}

V01.defaultProps = {"width":"100px","height":"100px","viewBox":"0 0 100 100","version":"1.1"};

module.exports = V01;

V01.default = V01;
